import { jsx as _jsx } from "react/jsx-runtime";
import Text from "@shared/components/contents/text/Text";
import React from "react";
import TextBlockWithTitle from "./TextBlockWithTitle";
const TextBlockWithTitlePreview = () => {
    return (_jsx(TextBlockWithTitle, { title: "Titre", text: _jsx(Text, { children: "Zone de texte libre" }) }));
};
export default TextBlockWithTitlePreview;
